module.exports = "Please apply for user / password by opening a <a href=\"https://support.hampager.de\" target=\"blank\">ticket</a> and select as Help Topic <b>New DAPNET Account</b>.<br /><br />Take a look at the <a href=\"http://hampager.de/dokuwiki/doku.php\" target=\"_blank\">DAPNET Wiki</a>.<br />If you were already registered in the old Funkrufmaster system, you can import your account <a href=\"http://www.hampager.de/dapnet-import\">here</a>."


//////////////////
// WEBPACK FOOTER
// ./src/store/config/defaultText.json
// module id = 7S5r
// module chunks = 1